export default __webpack_public_path__ + "static/banner-digital-shopping-options-allow-you-more-freedom-310eeaa3e684d1a3db1ebf65f0282191.jpg";